"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _material = require("@mui/material");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _wouter = require("wouter");
var _Style = require("../../style/Style");
var _form = require("../../components/form");
var _User = require("../../model/User");
var _common = require("../../store/common");
var _user = require("../../store/user");
var _course = require("../../store/course");
var _user2 = require("../../schema/user");
var _util = require("../../util");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const App = props => {
  const [learner, setLearner] = (0, _react.useState)(new _User.User());
  const [errors, setErrors] = (0, _react.useState)({});
  const [, setLocation] = (0, _wouter.useLocation)();
  const {
    setToastOpen,
    setToastText,
    setIsLoading,
    setLoadingMessage
  } = (0, _common.useCommonStore)();
  const {
    updateLearner,
    submitting
  } = (0, _user.useUserStore)();
  const {
    courses,
    fetchCourses
  } = (0, _course.useCourseStore)();
  const isEnableRef = (0, _react.useRef)(null);
  const submitButtonRef = (0, _react.useRef)(null);
  const onLoadingTextChanged = text => {
    setLoadingMessage(text);
  };
  const validate = () => {
    const result = _user2.updateLearnerSchema.safeParse(learner.data);
    if (result.success) return true;
    console.log((0, _util.parseErrors)(result.error.errors));
    setErrors((0, _util.parseErrors)(result.error.errors));
    return false;
  };
  (0, _react.useEffect)(() => {
    (async () => {
      setIsLoading(true);
      await fetchCourses();
      setLearner(await _User.User.getByID(props.id));
      setIsLoading(false);
    })();
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    ...stylex.props(_Style.wrapper.main),
    spacing: 4,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        ...stylex.props(_Style.buttonStyle.secondary),
        onClick: () => {// setLocation('/admin')
        },
        children: "\uFF1C\u623B\u308B"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      container: true,
      ...stylex.props(_Style.wrapper.mainTitle),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.textStyle.h1),
        children: "\u30E6\u30FC\u30B6\u30FC\u66F4\u65B0"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      spacing: 2,
      direction: 'column',
      ...stylex.props(_Style.wrapper.stretchW),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldInput, {
        label: "\u30E6\u30FC\u30B6\u30FC\u540D",
        type: "text",
        value: learner.name,
        errorText: errors.name,
        placeholder: 'ユーザーの名前を入力してください(他のユーザーと重複不可)',
        onChange: event => {
          const name = event.target.value;
          learner.name = name;
          setLearner(new _User.User(learner));
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldCheckboxes, {
        label: "\u5C65\u4FEE\u3059\u308B\u30B3\u30FC\u30B9",
        items: courses.map(course => {
          var _learner$courses;
          return {
            key: course.id,
            label: course.name,
            checked: ((_learner$courses = learner.courses) === null || _learner$courses === void 0 ? void 0 : _learner$courses.includes(course.id)) || false
          };
        }),
        values: learner.courses,
        errorText: errors.courses,
        placeholder: '履修するコースを選択してください',
        onChecked: (key, checked) => {
          if (checked) {
            let courses = learner.courses || [];
            courses.push(key);
            learner.courses = courses;
            setLearner(new _User.User(learner));
          } else {
            let courses = learner.courses || [];
            learner.courses = courses.filter(course => course !== key);
            setLearner(new _User.User(learner));
          }
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldCheckbox, {
        label: "\u6709\u52B9/\u7121\u52B9",
        ref: isEnableRef,
        type: "checkbox",
        checked: learner.isEnable,
        errorText: errors.isEnable,
        placeholder: '有効にする',
        onChange: event => {
          const target = event.target;
          learner.isEnable = target.checked;
          setLearner(new _User.User(learner));
        },
        onEnterKey: () => {
          var _submitButtonRef$curr;
          (_submitButtonRef$curr = submitButtonRef.current) === null || _submitButtonRef$curr === void 0 ? void 0 : _submitButtonRef$curr.focus();
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        ...stylex.props(_Style.buttonStyle.primary),
        disabled: submitting,
        ref: submitButtonRef,
        onClick: async () => {
          setIsLoading(true);
          if (!validate()) {
            setToastText('入力内容をご確認ください。');
            setToastOpen(true);
            setIsLoading(false);
            return;
          }
          setIsLoading(false);
          if (!window.confirm('ユーザーを更新しますか？')) {
            return;
          }
          setIsLoading(true);
          const result = await updateLearner(learner, onLoadingTextChanged);
          if (!result) {
            setIsLoading(false);
            return false;
          }
          setToastOpen(true);
          setToastText('ユーザーを更新しました');
          setLocation('/users');
          setIsLoading(false);
          return;
        },
        children: submitting ? 'ユーザー更新中...' : 'ユーザー更新する'
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
        minHeight: 48,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          ...stylex.props(_Style.textStyle.error),
          children: errors.submit
        })
      })]
    })]
  });
};
var _default = exports.default = App;